export enum ProdutoImagemTipo {
  THUMBNAIL = 'THUMBNAIL',
  MEDIA = 'MEDIA',
  PRINCIPAL = 'PRINCIPAL',
  ZOOM = 'ZOOM'
}
